export type RussianPluralForms = readonly [one: string, few: string, many: string];

const RU_NUMBER_FORMATTER = new Intl.NumberFormat('ru-RU');

export function pluralizeRu(value: number, forms: RussianPluralForms): string {
  const absolute = Math.abs(Math.trunc(value));
  const mod10 = absolute % 10;
  const mod100 = absolute % 100;
  if (mod10 === 1 && mod100 !== 11) {
    return forms[0];
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return forms[1];
  }
  return forms[2];
}

export function formatCountRu(value: number, forms: RussianPluralForms): string {
  return `${RU_NUMBER_FORMATTER.format(value)} ${pluralizeRu(value, forms)}`;
}
